import React from 'react';
import paymentSystemIcons from '~/shared/constants/paymentIcons';

export type CardBrandName = keyof typeof paymentSystemIcons | 'diners' | 'unknown';

export interface CardBrandIconProps {
    brandName: CardBrandName;
}

export function CardBrandIcon({brandName}: CardBrandIconProps) {
    const type = brandName === 'diners' ? 'dinersclub' : brandName;
    if (type === 'unknown') {
        return <div className={'size-full rounded-full bg-neutral-40'} />;
    }
    return <img className={'size-full'} src={paymentSystemIcons[type]} alt={type} />;
}
